
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/smoothers",
      function () {
        return require("private-next-pages/admin/smoothers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/smoothers"])
      });
    }
  